import html from './template.html'

const template = document.createElement('template')
template.innerHTML = html

customElements.define(
    'municipality-picker-item',
    class MunicipalityPickerItemElement extends HTMLElement {
        static get allowedTypes() {
            return ['default', 'error']
        }

        constructor() {
            super()

            const shadow = this.attachShadow({ mode: 'open' })
            shadow.append(template.content.cloneNode(true))

            this.onClick = this.onClick.bind(this)
            this.onMouseEnter = this.onMouseEnter.bind(this)
            this.onMouseLeave = this.onMouseLeave.bind(this)
        }

        /**
         * Gets the indicator element from the Shadow DOM.
         * @returns {HTMLElement}
         */
        get indicator() {
            return this.shadowRoot.querySelector('.indicator')
        }

        /**
         * Gets andd sets the title value from the indicator element.
         */
        get tooltip() {
            return this.indicator.getAttribute('title')
        }

        set tooltip(value) {
            this.indicator.setAttribute('title', value)
        }

        /**
         * Gets and sets the href attribute value.
         */
        get href() {
            return this.getAttribute('href')
        }

        set href(value) {
            if ('string' === typeof value) {
                this.setAttribute('href', value)
            }
        }

        /**
         * Gets and sets the href attribute value.
         */
        get title() {
            return this.getAttribute('title')
        }

        set title(value) {
            if ('string' === typeof value) {
                this.setAttribute('title', value)
            }
        }

        /**
         * Gets and sets the highlight attribute value.
         */
        get highlight() {
            return this.hasAttribute('highlight')
        }

        set highlight(value) {
            if (value === true) {
                this.setAttribute('highlight', 'highlight')
            } else {
                this.removeAttribute('highlight')
            }
        }

        /**
         * Gets and sets the active attribute value.
         */
        get active() {
            return this.hasAttribute('active')
        }

        set active(value) {
            if (value === true) {
                this.setAttribute('active', 'active')
            } else {
                this.removeAttribute('active')
            }
        }

        /**
         * Gets and sets the type attribute value.
         */
        get type() {
            return this.getAttribute('type')
        }

        set type(value) {
            if (MunicipalityPickerItemElement.allowedTypes.includes(value)) {
                this.setAttribute('type', value)
            }
        }

        /**
         * Listen to the events.
         */
        connectedCallback() {
            if (this.type === null) {
                this.type === 'default'
            }

            this.addEventListener('click', this.onClick, true)
            this.addEventListener('mouseenter', this.onMouseEnter)
            this.addEventListener('mouseleave', this.onMouseLeave)
        }

        /**
         * Remove the event listeners.
         */
        disconnectedCallback() {
            this.addEventListener('click', this.onClick, true)
            this.removeEventListener('mouseenter', this.onMouseEnter)
            this.removeEventListener('mouseleave', this.onMouseLeave)
        }

        /**
         * Opens a new page with the set URL. Basically the same behavior as a link with target _blank.
         * @param {Event} event Click event object.
         */
        onClick(event) {
            const isButton = event.target.closest(
                'a.municipality-item-department'
            )
            if (isButton || this.href === null) {
                return
            }

            window.open(this.href, '_blank')
        }

        /**
         * Dispatch the municipalityhighlight event with the statcode of the current element.
         * @param {Event} event Event object
         * @returns {void}
         */
        onMouseEnter() {
            const statcode = this.id
            this.dispatchMunicipalityHighlight(statcode)
        }

        /**
         * Dispatch the municipalityhighlight event with null set.
         * @returns {void}
         */
        onMouseLeave() {
            this.dispatchMunicipalityHighlight(null)
        }

        /**
         * Dispatch the countychange on this element.
         * @param {string} statcode
         * @returns {void}
         */
        dispatchMunicipalityHighlight(statcode) {
            this.dispatchEvent(
                new CustomEvent('municipalityhighlight', {
                    bubbles: true,
                    detail: {
                        statcode,
                    },
                })
            )
        }
    }
)



// WEBPACK FOOTER //
// ./scripts/web-components/municipality-picker-item/index.js